import { User } from 'app/projects/user/src/lib/models/user';

export class CommunityUserToUserCommand {
    id: string;
    fullName: string;
    avatar = { src: '' };

    constructor(user: User, avatar: string) {
        this.id = user.id;
        this.fullName = user.fullName;
        if (avatar) {
            this.avatar.src = avatar;
        }
    }
}
